export const managerUsers = {
  usersList: {
    title: "Utenti registrati",
    subtitle: "Elenco degli utenti registrati sulla piattaforma.",
    columns: {
      id: "ID",
      name: "Nome",
      phone: "Telefono",
      email: "Email",
      accommodations: "Alloggi",
      sends: "Invii",
      checkin: "Check-in",
      registeredAt: "Data di registrazione",
    },
    states: {
      demo: "Versione demo",
      demoEnded: "Demo terminata",
      subscribed: "Abbonato",
      subscriptionExpired: "Abbonamento scaduto",
      queryError: "Errore nella query",
    },
    deleteAdvisor: {
      confirmMessage: "Sei sicuro di voler eliminare questo consulente?",
      confirmHeader: "Conferma",
    },
  },
  accommodationUser: {
    info: "Dettagli dell'alloggio",
  },
  dataUserOld: {
    accommodationsList: "Elenco degli alloggi",
    createAccommodation: "Crea alloggio",
    emptyMessage: "Nessun alloggio registrato",
    emptySubMessage: "Gli alloggi registrati dall'utente verranno visualizzati qui.",
  },
  checkins: {
    title: "Check-in completati",
  },
  checkinsPending: {
    title: "Check-in in sospeso o in corso",
  },
};
